import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import { withTranslation, withNamespaces } from "react-i18next";

// styles
import style from '../../Styles/Containers/Auth_Survey.module.css'

// component
import Header from '../../Components/Header/header'

// Const
import * as Const from '../../Data/const'

class AuthSurveyContainer extends Component {
    constructor() {
        super();
        this.state = {
        }
        this.handleInit = this.handleInit.bind(this);
    }

    handleInit() {
        Const.userAppCloseActivity();
    }

    render() {
      const { t } = this.props;

      return (
            <div className={style.container}>
                <Header 
                    onClosePress={(e)=>{
                        Const.userAppCloseActivity();
                    }}
                    content={t('submit_survey')}
                />
                <img className={style.icon} src={"https://d15eixcc3515pq.cloudfront.net/Assets/img/ic-complete.svg"}></img>
                <span className={style.font_big}>{Const.MESSAGE_TABLE[this.props.COUNTRY_CODE]['FEED_SUBMITTED']}</span>
                <span className={style.font_small}>{Const.MESSAGE_TABLE[this.props.COUNTRY_CODE]['FEED_SUBMITTED2']}</span>
                <div className={style.button_area}>
                    <div className={style.button} onClick={this.handleInit}>
                        {t('confirm')}
                    </div>
                </div>
            </div>
        )
    }
}

export default connect((state) => {
    return {
       eSESSION: state.data.eSESSION.eSESSION,
       COUNTRY_CODE: state.data.eSESSION.COUNTRY_CODE
    }
})(withRouter(withTranslation()(AuthSurveyContainer)))